module.exports = __webpack_public_path__ + "slovakia.svg?0c483c31b9ad01fc129241a2c508ccda";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/slovakia.svg
// module id = 294
// module chunks = 10